import { createSlice } from '@reduxjs/toolkit'

const initialState = {

  cartItem: localStorage.getItem("cartItem") ? JSON.parse(localStorage.getItem("cartItem")) : [],
  cartTotalQuantity: 0,
  cartTotalAmount: 0

}

export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {

    addToCart: (state, action) => {

      const itemIndex = state.cartItem.findIndex(item => item.id === action.payload.id)
      if (itemIndex >= 0) {
        state.cartItem[itemIndex].quantity += 1;
      }
      else {
        const tempProduct = { ...action.payload, quantity: 1 }
        state.cartItem.push(tempProduct)

      }

      localStorage.setItem("cartItem", JSON.stringify(state.cartItem))


    },

    removeToCart: (state, action) => {

      const removedCartItem = state.cartItem.filter(item => item.id !== action.payload.id)
      state.cartItem = removedCartItem;
      localStorage.setItem("cartItem", JSON.stringify(state.cartItem))


    },

    decreseQuantity: (state, action) => {
      const itemIndex = state.cartItem.findIndex(item => item.id === action.payload.id)
      if (state.cartItem[itemIndex].quantity > 1) {
        state.cartItem[itemIndex].quantity -= 1
      }
      else {
        const removedCartItem = state.cartItem.filter(item => item.id !== action.payload.id)
        state.cartItem = removedCartItem;
        localStorage.setItem("cartItem", JSON.stringify(state.cartItem))
      }
    },
    increseQuantity: (state, action) => {

      const itemIndex = state.cartItem.findIndex(item => item.id === action.payload.id)
      state.cartItem[itemIndex].quantity += 1
    },
    handleClear: (state) => {
      state.cartItem = []
      localStorage.setItem("cartItem", JSON.stringify(state.cartItem))

    },
    getTotal: (state, action) => {
      let { total, quantity } = state.cartItem.reduce((cartTotal, cartItem) => {

        const { price, quantity } = cartItem;
        const productPrice = parseInt(price)
        let itemTotal = productPrice * quantity;
        cartTotal.total += itemTotal;
        cartTotal.quantity += quantity
        return cartTotal

      },


        {
          total: 0,
          quantity: 0
        })

      state.cartTotalQuantity = quantity;
      state.cartTotalAmount = total;

    }

  },
})

export const { addToCart, removeToCart, decreseQuantity, increseQuantity, handleClear, getTotal } = counterSlice.actions

export default counterSlice.reducer